
module.exports = [
    {
        "idPrimary": 196730347,
        "idDisplayStyle": 1,
        "ordinal": 2,
        "fieldKey": "field_6",
        "contentGroup": "specification",
        "displayGroup": "B",
        "maxLength": 20,
        "applyDropCap": "",
        "enableLimitOverride": false,
        "displayLabel": "first field",
        "defaultValue": "",
        "required": 0,
        "isEditable": true,
        "visible": true,
        "allowSuggestedComments": true,
        "message": null,
        "msgType": null,
        "idTemplateFieldFormat": null,
        "fieldFormatName": null,
        "formatType": null,
        "data": ""
    },
    {
        "idPrimary": 196730348,
        "idDisplayStyle": 1,
        "ordinal": 1,
        "fieldKey": "field_68",
        "contentGroup": "specification",
        "displayGroup": "B",
        "maxLength": 36,
        "applyDropCap": "",
        "enableLimitOverride": false,
        "displayLabel": "Call to Action:",
        "defaultValue": "",
        "required": 0,
        "isEditable": true,
        "visible": true,
        "allowSuggestedComments": true,
        "message": null,
        "msgType": null,
        "idTemplateFieldFormat": null,
        "fieldFormatName": null,
        "formatType": null,
        "data": ""
    },
    {
        "idPrimary": 196730349,
        "idDisplayStyle": 1,
        "ordinal": 3,
        "fieldKey": "field_7",
        "contentGroup": "specification",
        "displayGroup": "B",
        "maxLength": 20,
        "applyDropCap": "",
        "enableLimitOverride": false,
        "displayLabel": "second field",
        "defaultValue": "",
        "required": 6,
        "isEditable": true,
        "visible": true,
        "allowSuggestedComments": true,
        "message": null,
        "msgType": null,
        "idTemplateFieldFormat": null,
        "fieldFormatName": null,
        "formatType": null,
        "data": ""
    }
];

